import {Component, Input} from '@angular/core';
import {Platform} from 'ionic-angular';

@Component({
  selector: 'app-static-map',
  templateUrl: './static-map.html',
})
export class StaticMapComponent {
  @Input() location: {};
  height: number = 200;
  width: number;

  icon = 'https://staging-fitpass.firebaseapp.com/assets/img/map/selected%20small.png';

  constructor(public platform: Platform) {
    platform.ready().then(() => {
      this.width = platform.width() - 40;
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/static-map/static-map.ts